export const whatHappenedData = {
  title: 'What problems did you experience on the holiday?',
  imgObj: {
    src: 'https://media.product.which.co.uk/prod/images/original/5cfade49bec3-tooliconlifering.jpg',
    alt: '',
  },
  note: [
    'What you write here will appear in the final letter of the claim, so please be as clear as possible, including dates.',
  ],
  descriptiveText: [
    'Please tell us how the holiday company did not fulfil what they promised (and therefore breached their contract with you)',
  ],
  placeholderText:
    'Eg. the holiday company promised the accommodation would be a 5 star hotel but it was not.',
}
